// IMPORTS
import _ from 'lodash'
import axios from 'axios'
import Db from '@/dixie.js'

let cabeceraTocloneDeep = {
    id_proveedor_fk: null,
    numero: null,
    monto: 0,
    fecha: null,
    fechaEntrega: null,
    cod_seg: null,
    nombreRecibe: null,
    approved: false,
    reporte_compras_id: null
  },
  emptyItem = {
    definedBy: null, // [report|foundInServer|newItem]
    codigo: null,
    productoTitle: null,
    producto: null,
    pedidos: [],
    monto: null,
    cantidad: null,
    precio_venta: null,
    iva_incluido: false,
    itemFoundInReport: {
      id_pk: null,
      text: null,
      item: {}
    },
    itemFound: {
      id_pk: null,
      text: null,
      item: {}
    },
    itemNuevo: {
      tipo: null,
      elemento: {
        value: null,
        id_pk: null,
        item: {}
      },
      marca: {
        value: null,
        id_pk: null,
        item: {}
      },
      tipopresentacion: null,
      presentacion: null,
      unidad: null
    }
  }

const state = {
  cabecera: {},
  elementos: [],
  actualizacionPedidos: []
}

state.cabecera = _.cloneDeep(cabeceraTocloneDeep)
state.elementos.push(_.cloneDeep(emptyItem))

const getters = {
  facturacionIsValid: (state) => {
    let isValida  = true,
        montoElementos = 0
    _.forEach(state.elementos, (item) => {
      montoElementos += parseFloat(item.monto)
      if(!item.monto || item.monto < 0 || !item.cantidad || !item.venta)
        isValida = false;
    })
    if(!state.cabecera.id_proveedor_fk)
      isValida = false
    if(!state.cabecera.monto)
      isValida = false
    if(parseFloat(state.cabecera.monto).toFixed(2) != parseFloat(montoElementos).toFixed(2))
      isValida = false
    if(!state.cabecera.numero)
      isValida = false
      console.log("montoElementos", parseFloat(montoElementos).toFixed(2), parseFloat(state.cabecera.monto).toFixed(2))
    return isValida
  },
  facturacionGetTotal: (state) => {
    let total  = 0
    _.forEach(state.elementos, (item) => {
      if(!!item.monto)
        total += parseFloat(item.monto)
    })
    return parseFloat(total).toFixed(2)
  },
  facturacionGetCabecera: (state) => {
    return state.cabecera
  },
  facturacionGetElementos: (state) => {
    return state.elementos
  },
  facturacionGetActualizacionPedidos: (state) => {
    return state.actualizacionPedidos
  },
}

const mutations = {
  facturacionUpdateItem: (state, payload) => {
    state.elementos[payload.index] = payload.item
  },
  facturacionWriteDixie: (state) => {
    console.log('facturacionWriteDixie triggered!')
    Db.configs.where('key').equalsIgnoreCase('facturacionState').delete().then(() => {
      Db.configs.add({
        key: 'facturacionState',
        value: JSON.stringify(state)
      })
    })
  },
  facturacionAddEmptyItem: (state) => {
    state.elementos.push(_.cloneDeep(emptyItem))
  },
  facturacionRemoveItemByIndex: (state, payload) => {
    let arr = _.cloneDeep(state.elementos)
    arr.splice(payload, 1) // REMOVES INDEX 3 ALREADY IN arr
    state.elementos = arr
  },
  facturacionClean: (state) => {
    let toKeep = {
      nombreCaptura: _.clone(state.cabecera.nombreCaptura),
      nombreCompra: _.clone(state.cabecera.nombreCompra),
      nombreRecibe: _.clone(state.cabecera.nombreRecibe),
    }
    state.cabecera = {}
    state.cabecera = _.cloneDeep(cabeceraTocloneDeep)
    state.cabecera.nombreCaptura = _.clone(toKeep.nombreCaptura)
    state.cabecera.nombreCompra = _.clone(toKeep.nombreCompra)
    state.cabecera.nombreRecibe = _.clone(toKeep.nombreRecibe)
    state.elementos = [_.cloneDeep(emptyItem)]
    state.actualizacionPedidos = []
    Db.configs.where('key').equalsIgnoreCase('facturacionState').delete()
  },
  facturacionSetApproved: (state) => {
    state.cabecera.approved = true
  },

  facturacionLoadupFromDixie: (state, payload) => {
    // HOT UPDATE
    _.forEach(payload, (item, key) => {
      state[key] = item
    })
    // state = payload
  }
}

const actions = {
  facturacionFromDixie: ({
    commit
  }) => {
    return new Promise((success) => {
      Db.configs.where('key').equalsIgnoreCase('facturacionState').first().then(facturacionState => {
        commit('facturacionLoadupFromDixie', JSON.parse(facturacionState.value))
        setTimeout(() => {
          success(true)
        }, 250)
      }).catch(() => {
        setTimeout(() => {
          success(false)
        }, 250)
      })
    })
  },
  facturacionCheckInit: ({
    getters,
    commit
  }) => {
    return new Promise((success) => {
      if (getters.facturacionGetCabecera.fecha) {
        axios.post('facturacion/tryinit', getters.facturacionGetCabecera)
          .then((response) => {
            if (response.status) {
              commit('facturacionSetApproved')
              commit('reporteComprasSetLocalData', response.data)
            }
            success(response)
          })
      } else {
        success()
      }
    })
  },
  facturacionProcess: ({
    getters,
    commit
  }) => {
    return new Promise((success, fail) => {
      if (getters.facturacionIsValid) {
        axios.post('facturacion/process', _.merge(state, {reportes_compras_id: getters.reporteComprasGetID}))
          .then((response) => {
            console.log("response.facturacionProcess", response)
            if (response.status) {
              commit('facturacionClean')
              success(response)
            } else {
              fail()
            }

          })
      } else {
        success()
      }
    })
  }
}

// EXPORTS
export default {
  state,
  getters,
  mutations,
  actions
};
